import { withAuthenticationRequired } from "@auth0/auth0-react";
import { ComponentType, useMemo } from "react";

export const ProtectedRoute = ({ component }: { component: ComponentType }) => {
  const Component = useMemo(() => withAuthenticationRequired(component), [component]);
  return <Component />;
};
